<uni-snackbar></uni-snackbar>
<uni-nav-new>
  <router-outlet></router-outlet>
</uni-nav-new>
